module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: _vm.ref,
    staticClass: "f-nav-image"
  }, [_c('div', {
    staticClass: "outer-wrap",
    style: (_vm.outerWrapStyle)
  }, [_c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "list-wrap",
    style: (_vm.listWrapStyle)
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "list",
      class: {
        'active': item.active
      },
      attrs: {
        "index": index
      },
      on: {
        "click": _vm.onListClickHandle
      }
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl.replace(/^http:|https:/, _vm.location.protocol),
        "alt": item.text
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "slider",
    style: (_vm.sliderStyle)
  })], 2)])]), _vm._v(" "), (_vm.categoryBar) ? _c('div', {
    staticClass: "category-bar",
    style: (_vm.categoryBarStyle),
    on: {
      "click": _vm.onBarClickHandle
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.categoryBar.imageUrl.replace(/^http:|https:/, _vm.location.protocol)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow"
  })]) : _vm._e()])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-c0ff4e7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c0ff4e7e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/nav/nav-image.vue
// module id = 22
// module chunks = 0